import React from "react";
import LegalPage, { useLegalLabels } from "./LegalPage";
import { privacyContent } from "./legalContent";
import { useLang } from "@/i18n/LanguageContext";

const PrivacyPage = () => {
  const { t } = useLang();
  const { back, lang } = useLegalLabels();
  return (
    <LegalPage
      testId="privacy-page"
      updated={t.privacy.updated}
      title={t.privacy.title}
      sections={privacyContent[lang]}
      backLabel={back}
    />
  );
};

export default PrivacyPage;
